import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	qrCodePortlet: {
		borderLeft: `6px solid ${colors.green[500]}`,
		padding: "32px 16px"
	},
	sessionPortlet: {
		padding: "32px 24px"
	},
	boldText: {
		fontWeight: "bold"
	},
	actionButton: {
		width: 220,
		display: "flex",
		justifyContent: "flex-start",

		color: colors.getPrimaryColor(),
		background: colors.gray[0],
		fontSize: "14px",
		fontWeight: 500
	},
	connectWppText: {
		color: colors.gray[700],
		fontWeight: "bold"
	}
})

export default useStyles
